import { Component, HostBinding, OnDestroy } from '@angular/core';
import { LayoutService } from '@assetaccountant/core/services/layout.service';

@Component({
  selector: 'app-payment-required',
  templateUrl: './payment-required.component.html',
  styleUrls: ['./payment-required.component.scss'],
  standalone: false,
})
export class PaymentRequiredComponent implements OnDestroy {
  show = false;

  @HostBinding('class.d-none')
  get displayNone() {
    return !this.show;
  }

  private subscription = this.layoutService.showPaymentRequired.subscribe(
    paymentRequired => (this.show = paymentRequired),
  );

  constructor(private layoutService: LayoutService) {}

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
